module.exports = __webpack_public_path__ + "static/favicon-adab6ec1c8f3921521cce65c153c6667.ico";